import { CALL_API } from '../middleware/ApiMiddleware';

export const CASE_TYPES_FETCH_REQUEST = 'CASE_TYPES_FETCH_REQUEST';
export const CASE_TYPES_FETCH_SUCCESS = 'CASE_TYPES_FETCH_SUCCESS';
export const CASE_TYPES_FETCH_FAILURE = 'CASE_TYPES_FETCH_FAILURE';

export const CASE_TYPE_CREATE_REQUEST = 'CASE_TYPE_CREATE_REQUEST';
export const CASE_TYPE_CREATE_SUCCESS = 'CASE_TYPE_CREATE_SUCCESS';
export const CASE_TYPE_CREATE_FAILURE = 'CASE_TYPE_CREATE_FAILURE';

export const CASE_TYPE_EDIT_REQUEST = 'CASE_TYPE_EDIT_REQUEST';
export const CASE_TYPE_EDIT_SUCCESS = 'CASE_TYPE_EDIT_SUCCESS';
export const CASE_TYPE_EDIT_FAILURE = 'CASE_TYPE_EDIT_FAILURE';

const baseURL = (agencyId, productId) => `agencies/${agencyId}/products/${productId}/config/case-types`;

export const fetchCaseTypes = (agencyId: number, productId: number) => ({
  [CALL_API]: {
    endpoint: baseURL(agencyId, productId),
    method: 'get',
    authenticated: true,
    types: [CASE_TYPES_FETCH_REQUEST, CASE_TYPES_FETCH_SUCCESS, CASE_TYPES_FETCH_FAILURE],
  },
});

export const createCaseType = (agencyId: number, productId: number, caseType: ICaseType) => ({
  [CALL_API]: {
    endpoint: baseURL(agencyId, productId),
    method: 'post',
    authenticated: true,
    body: caseType,
    types: [CASE_TYPE_CREATE_REQUEST, CASE_TYPE_CREATE_SUCCESS, CASE_TYPE_CREATE_FAILURE],
  },
});

export const editCaseType = (agencyId: number, productId: number, caseTypeId: number, caseType: ICaseType) => ({
  [CALL_API]: {
    endpoint: `${baseURL(agencyId, productId)}/${caseTypeId}`,
    method: 'put',
    authenticated: true,
    body: caseType,
    types: [CASE_TYPE_EDIT_REQUEST, CASE_TYPE_EDIT_SUCCESS, CASE_TYPE_EDIT_FAILURE],
  },
});
